const STRINGS = {
  header: {
    support: 'Contacta a Maya para soporte',
    shop: 'Mercado',
    account: 'Cuenta'
  },
  footer: {
    logout: 'Cerrar sesión',
    change_language: 'Cambiar idioma'
  },
  content: {
    loading: 'Cargando'
  },
  shop: {
    transaction_type: 'Tipo de transacción',
    product: 'Productos',
    details: 'Detalles',
    review: 'Carrito de compras',
    loading: 'Cargando'
  },
  account: {
    transactions: 'Transacciones',
    reports: 'Reportes',
    manage_employees: 'Gestionar Empleados'
  },
  reports: {
    history: 'Historial',
    generate_report: 'Generar reporte',
    generate_quick_report: 'Reporte rápido detallado',
    report_type: 'Tipo de reporte',
    short_report: 'Reporte corto',
    report_summary: 'Resumen del reporte',
    detailed_report: 'Reporte detallado',
    daily_report: 'Hoy',
    weekly_report: 'Esta semana',
    monthly_report: 'Este mes',
    custom_dates_report: 'Reporte por fechas personalizadas',
    print_report: 'Imprimir reporte',
    created_date: 'Fecha de creación',
    type: 'Tipo',
    from: 'Desde',
    to: 'Hasta',
    report_dates: 'Rango de fechas del reporte',
    no_reports: 'No hay reportes para este periodo',
    manual_reports: 'Manual',
    reports_table_title: 'Historial de reportes generados previamente',
    automatic_reports: 'Automático',
    settings_reports: 'Ajustes',
    enable_automatic_report: 'Habilitar reporte automático diario',
    add_email: 'Introduce la dirección de correo electrónico',
    submit: 'Enviar',
    select_day_of_week: 'Selecciona los días de la semana para recibir reportes',
    add_emails: 'Añade direcciones de correo si deseas recibir copias del reporte por correo',
    week_day_0: 'Domingo',
    week_day_1: 'Lunes',
    week_day_2: 'Martes',
    week_day_3: 'Miércoles',
    week_day_4: 'Jueves',
    week_day_5: 'Viernes',
    week_day_6: 'Sábado'
  },
  reports_settings: {
    device: 'Dispositivo',
    assigned_employee: 'Empleado asignado',
    manual_enabled: 'Reporte manual habilitado',
    automatic_enabled: 'Reporte automático habilitado',
    no_devices: 'No hay dispositivos',
    select_all: 'Seleccionar todo'
  },
  clerks_management: {
    too_short: 'Demasiado corto',
    too_long: 'Demasiado largo',
    required: 'Campo requerido',
    invalid_email: 'Correo electrónico no válido',
    server_validation_error: 'Error de validación en el servidor',
    first_name: 'Nombre',
    last_name: 'Apellido',
    employee_name: 'Nombre del empleado',
    phone: 'Teléfono',
    email: 'Correo electrónico',
    old_password: 'Contraseña antigua',
    new_password: 'Contraseña nueva',
    confirm_new_password: 'Confirmar contraseña nueva',
    password: 'Contraseña',
    confirm_password: 'Confirmar contraseña',
    create: 'Crear',
    create_clerk: 'Crear empleado',
    create_device: 'Crear dispositivo',
    password_short: '¡La contraseña debe tener más de 8 caracteres!',
    password_not_the_same: '¡Las contraseñas no coinciden!',
    dont_match_phone: 'Rellena correctamente',
    device: 'Dispositivo',
    attached_user: 'Empleado asignado',
    enabled: 'Habilitado',
    device_name: 'Nombre del dispositivo',
    device_without_user: 'Dispositivo sin usuario',
    devices_not_found: 'Dispositivos no encontrados',
    employees_not_found: 'Empleados no encontrados',
    select_employee: 'Selecciona un empleado',
    edit: 'Editar',
    edit_employee: 'Editar información del empleado',
    device_update: 'Actualizar dispositivo',
    save: 'Guardar',
    own_device: 'Este es tu dispositivo actual',
    only_active_devices: 'Mostrar solo dispositivos activos',
    devices: 'Dispositivos',
    employees: 'Empleados',
    change_password: 'Cambiar contraseña',
    submit: 'Enviar',
    unexpected_error: 'Error inesperado',
    password_changed: 'La contraseña ha sido cambiada',
    user_edit_success: 'La información del empleado ha sido actualizada',
    assign_on_me: 'Asignado a mí',
    store_owner_device: 'El dispositivo pertenece a otro propietario',
    my_user: 'Mi usuario'
  },
  transactions: {
    transaction_not_found: 'Transacciones no encontradas',
    customer: 'Cliente',
    received: 'Recibido',
    total_amount: 'Monto total',
    total_price: 'Precio total',
    total_fee: 'Tarifa total',
    created_date: 'Fecha de creación',
    price: 'Precio',
    fee: 'Tarifa',
    total: 'Total',
    cancel_modal_header: 'Cancelar transacción',
    cancelled: 'Cancelado',
    cancel_modal_text: '¿Deseas cancelar la transacción?',
    print_receipt: 'Imprimir recibo'
  },
  login: {
    phone_number: 'Número de teléfono',
    password: 'Contraseña',
    login: 'Iniciar sesión',
    submit: 'Enviar',
    back_to_login: 'Regresar',
    select_device: 'Selecciona un dispositivo',
    user_not_found_title: 'Empleado no encontrado',
    user_not_found_message: 'Por favor contacta a soporte de Maya para registrarte',
    access_denied_title: 'Acceso denegado',
    access_denied_message: 'No tienes acceso a Maya OTC',
    device_not_found_title: 'Dispositivo no encontrado',
    device_not_found_message: 'Por favor contacta a soporte de Maya',
    invalid_grant_title: 'Error de credenciales',
    invalid_grant_message: 'Número de teléfono o contraseña incorrectos',
    sso_error_title: 'Error del servidor',
    sso_error_message: 'Por favor contacta a soporte de Maya',
    phone_number_invalid_title: 'Error de validación',
    phone_number_invalid_message: 'Número de teléfono no válido',
    password_invalid_title: 'Error de validación',
    password_invalid_message: 'Contraseña no ingresada',
    unexpected_error_title: 'Error inesperado',
    unexpected_error_message: 'Por favor contacta a soporte de Maya',
    add_new_clerk: 'Añadir nuevo empleado',
    select_clerk: 'Selecciona un empleado de la lista'
  },
  categories: {
    pay_any_bill: 'Pagar cualquier factura',
    pin_products: 'Productos PIN',
    phone_reload: 'Recarga telefónica',
    international_topup: 'Recarga internacional',
    card_reload: 'Recarga de tarjeta',
    check_cashing: 'Cobro de cheques'
  },
  products: {
    no_products: 'Productos no encontrados',
    no_favorites: 'No hay productos favoritos',
    favorites: 'Favoritos',
    search: 'Escribe para buscar',
    reset: 'Restablecer'
  },
  billers: {
    favorites: 'Facturadores favoritos',
    no_favorites: 'No hay facturadores favoritos',
    biller_search: 'Búsqueda de facturador',
    no_results: 'Sin resultados',
    po_box: 'Apartado postal',
    zip: 'Código postal',
    biller_name: 'Nombre del facturador',
    biller_name_placeholder: 'Escribe el nombre del facturador',
    or: 'O',
    search: 'Buscar',
    results: 'Resultados de búsqueda'
  },
  app_not_found: {
    not_found: 'Aplicación no encontrada',
    support: 'Contacta a Maya para soporte',
    back: 'Salir'
  },
  pay_any_bill: {
    processing_type: 'Selecciona el tipo de procesamiento',
    priority: 'Prioridad',
    standard: 'Estándar',
    account: 'Cuenta #',
    confirm_account: 'Confirma la cuenta #',
    bill_image: 'Imagen de la factura',
    account_again: 'Cuenta nuevamente #',
    submit: 'Enviar',
    account_number_not_equal_confirm_account: 'El número de cuenta debe ser igual al de confirmación',
    account_number_not_valid_header: 'Número de cuenta no válido',
    account_number_not_valid_content: 'Por favor verifica el número de cuenta e intenta de nuevo',
    bill_image_processing_error_header: 'La imagen no fue procesada',
    bill_image_processing_error_content: 'Por favor revisa la calidad de la imagen y vuelve a escanearla',
    unexpected_error: 'Error inesperado',
    select_account: 'Selecciona la cuenta previa del cliente',
    back: 'Atrás',
    manual_entering: 'Entrada manual',
    get_account_number: 'Obtener número de cuenta'
  },
  amounts: {
    phone_number: 'Número de teléfono del cliente',
    phone_number_confirm: 'Confirma el número de teléfono del cliente',
    phone_number_not_valid_header: 'Número de teléfono no válido',
    phone_number_not_valid_content: 'Por favor verifica el número del cliente e intenta de nuevo',
    limit: 'límite de monto',
    confirm: 'Confirmar',
    change_customer: 'Cambiar cliente',
    enter_amount: 'Monto ingresado',
    amount_paid: 'Cantidad pagada',
    fee: 'Tarifa',
    total_amount: 'Monto total',
    discount_amount: 'Descuento'
  },
  app_navigation: {
    back: 'Atrás',
    next: 'Siguiente',
    confirm: 'Confirmar',
    submit: 'Enviar transacción',
    support_message: 'Contacta a Maya para soporte'
  },
  shopping_cart: {
    amount_paid: 'Cantidad pagada',
    fee: 'Tarifa',
    total_amount: 'Monto total',
    account: 'Cuenta',
    card_number: 'Número de tarjeta',
    change: 'Cambio',
    empty_cart: 'El carrito de compras está vacío',
    customer: 'Cliente',
    product_name: 'Nombre del producto',
    details: 'Detalles',
    created_date: 'Fecha de creación',
    amount: 'Cantidad',
    select_all: 'Seleccionar todos los productos',
    delete_payment: 'Eliminar pago',
    delete_payment_details: '¿Estás seguro de que deseas eliminar este pago?',
    yes: 'Sí',
    no: 'No',
    pay_for_products: 'Pagar por los productos',
    print_receipt: 'Imprimir recibo',
    print_general_receipt: 'Imprimir un recibo general',
    add_another_transaction: 'Agregar otra transacción',
    add_transaction: 'Agregar transacción',
    enter_amount_received: 'Ingresa la cantidad recibida'
  },
  timeout_overlay: {
    title: '¿Necesitas más tiempo?',
    description: 'Se cerrará tu sesión automáticamente después de',
    yes: 'Sí, necesito más tiempo',
    no: 'No, salir a iniciar sesión'
  },
  error_overlay: {
    auth_token_error: 'Has iniciado sesión desde otro navegador. La sesión actual ha expirado',
    logout: 'Se cerrará tu sesión automáticamente en 5 seg',
    unexpected_error: 'Error inesperado',
    access_denied: 'Tu token de acceso ha expirado',
    device_not_found: 'Dispositivo no encontrado',
    user_not_found: 'Usuario no encontrado'
  },
  phonereload: {
    enter_amount: 'Ingresa la cantidad',
    select_amount: 'Selecciona la cantidad...',
    invalid_number: 'Número de teléfono no válido',
    invalid_operator: 'Operador no válido',
    invalid_metropcs_number: 'Número de MetroPCS no válido',
    invalid_boostmobile_number: 'Número de BoostMobile no válido'
  },
  international_phonereload: {
    enter_amount: 'Ingresa la cantidad',
    select_amount: 'Selecciona la cantidad...',
    phone_number: 'Número de teléfono',
    recipient_phone_number: 'Número de teléfono del destinatario',
    invalid_number: 'Número de teléfono no válido',
    invalid_operator: 'Operador no válido',
    invalid_metropcs_number: 'Número de MetroPCS no válido',
    invalid_boostmobile_number: 'Número de BoostMobile no válido',
    invalid_recipient_number: 'Número de destinatario no válido'
  },
  phonereload_ez_bill: {
    pin: 'PIN',
    enter_pin: 'Ingresa el PIN',
    select_amount: 'Selecciona la cantidad...',
    enter_amount: 'Ingresa la cantidad',
    phone_number: 'Número de teléfono',
    recipient_phone_number: 'Número de teléfono del destinatario',
    invalid_recipient_number: 'Número de destinatario no válido'
  },
  scanner: {
    scanner_not_found: 'Escáner no encontrado',
    scanner_download_title: '¡Instala la aplicación Maya OTC y comienza a escanear ahora!*',
    scanner_download_content: '*solo si cuentas con un dispositivo escáner',
    scanner_download_button: 'Descargar la aplicación Maya OTC'
  },
  camera: {
    capture_photo: 'Capturar foto',
    close_camera: 'Cerrar cámara',
    loading: 'Cargando',
    user_media_error: 'Sin acceso a la cámara'
  },
  modal: {
    header: '¿Estás seguro?',
    yes: 'Sí',
    no: 'No'
  },
  cash_reload: {
    warning: '*Debes tener un dispositivo lector de tarjetas para usar ese producto',
    cardholder_name: 'Nombre del titular de la tarjeta',
    account: 'Cuenta',
    balance: 'Saldo',
    check_balance: 'Verificar saldo'
  },
  check_cashing: {
    customer_photo: 'Foto del cliente',
    first_name: 'Nombre',
    middle_name: 'Segundo nombre',
    last_name: 'Apellido',
    gender: 'Género',
    male: 'Masculino',
    female: 'Femenino',
    unknown: 'Desconocido',
    reset: 'Restablecer',
    email: 'Correo electrónico',
    ssn: 'Número de seguro social',
    cell_phone: 'Teléfono móvil',
    home_phone: 'Teléfono fijo',
    search_customer: 'Buscar cliente',
    search_placeholder: 'Escribe para buscar',
    create_new_customer: 'Crear nuevo cliente',
    date_of_birth: 'Fecha de nacimiento',
    customer_status: 'Estado del cliente',
    status_good: 'Bueno',
    status_neutral: 'Neutral',
    status_bad: 'Malo',
    status_high_risk: 'Alto riesgo',
    address: 'Dirección',
    address1: 'Dirección 1',
    address2: 'Dirección 2',
    address_city: 'Ciudad',
    address_state: 'Estado',
    address_zip: 'Código postal',
    address_search: 'Búsqueda de dirección',
    id_details: 'Detalles de identificación del cliente',
    id_type: 'Tipo de identificación',
    id_number: 'Número de identificación',
    id_issuer: 'Emisor',
    id_expiration_date: 'Fecha de vencimiento',
    id_front_image: 'Imagen frontal de la identificación',
    id_back_image: 'Imagen trasera de la identificación',
    capture_photo: 'Capturar una foto',
    cancel: 'Cancelar',
    create_customer: 'Crear nuevo cliente',
    change_customer: 'Cambiar cliente',
    search: 'Buscar',
    passport: 'Pasaporte',
    id_card: 'Tarjeta de identificación',
    reset_scanning: 'Restablecer escaneo',
    scan_check: 'Escanear un cheque',
    aba_number: 'Número ABA',
    account_number: 'Número de cuenta',
    check_number: 'Número del cheque',
    check_date: 'Fecha del cheque',
    scan_image: 'Por favor, escanea un cheque',
    scan_image_description: 'Escanea un cheque para continuar...',
    image_not_scanned: 'Imagen no escaneada',
    front_image_not_scanned: 'Imagen frontal no escaneada',
    back_image_not_scanned: 'Imagen trasera no escaneada',
    check_front_image: 'Imagen frontal del cheque',
    check_back_image: 'Imagen trasera del cheque',
    recognize_images: 'Reconocer imágenes',
    check_maker_name: 'Nombre del emisor del cheque',
    check_maker_address: 'Dirección del emisor',
    check_maker_city: 'Ciudad del emisor',
    check_maker_state: 'Estado del emisor',
    check_maker_zip: 'Código postal del emisor',
    check_amount: 'Monto del cheque',
    check_raw_micr: 'MICR del cheque sin procesar',
    check_payee_name: 'Nombre del beneficiario',
    cash_a_check: 'Cobrar un cheque',
    fee: 'Tarifa',
    customer_amount: 'Dispensar al cliente'
  },
  check_cashing_validation: {
    customer_id_required: 'Se requiere la identificación del cliente',
    s_customer_id_required: 'Se requiere la identificación del cliente de servicio',
    check_image_front_incorrect: 'URL de imagen frontal incorrecta',
    check_image_back_incorrect: 'URL de imagen trasera incorrecta',
    check_image_front_required: 'Se requiere la imagen frontal',
    check_image_back_required: 'Se requiere la imagen trasera',
    check_date_incorrect: 'Fecha incorrecta',
    min_amount: 'Monto mínimo - {{amount}}',
    max_amount: 'Monto máximo - {{amount}}',
    updating_amounts: 'Actualizando montos...'
  },
  check_cashing_statuses: {
    unexpected: 'Estado de transacción inesperado',
    approved: 'La transacción ha sido aprobada',
    review: 'La transacción ha sido enviada a revisión',
    bad_images: 'Los datos del cheque no se reconocen completamente. Puedes llenar los datos manualmente o volver a escanear',
    bad_maker: 'Emisor inválido. No podemos aceptar el cheque de este emisor',
    canceled: 'La transacción ha sido cancelada',
    internal: 'Error interno',
    not_parsed: 'No podemos analizar el MICR',
    not_recognized: 'Los datos del cheque no se reconocen completamente. Puedes llenar los datos manualmente o volver a escanear'
  },
  check_cashing_review: {
    title: 'La transacción se ha creado con éxito',
    cancel_transaction: 'Cancelar transacción',
    approve_transaction: 'Aprobar transacción'
  },
  validation: {
    min: 'El campo debe tener más de {{count}} caracteres!',
    max: 'El campo no debe tener más de {{count}} caracteres!',
    required: '¡Campo requerido!',
    email: '¡El campo debe ser un correo electrónico!',
    date: '¡El campo debe ser una fecha!',
    invalid_phone: 'Número de teléfono no válido',
    invalid_email: 'Dirección de correo no válida',
    duplicated_ssn: 'Ya existe un cliente con este número de seguro social',
    duplicated_id: 'Ya existe un cliente con esta información de identificación'
  }
};

export default STRINGS;



// WEBPACK FOOTER //
// ./src/i18n/es_MX.js